import ScreenerIndicatorFieldsFragment from "components/screener/v2/query/ScreenerIndicatorFieldsFragment";
import gql from "graphql-tag";

export default gql`
  query ScreenerFilterableIndicators($input: ScreenerFilterableIndicatorsInput!) {
    screenerFilterableIndicators(input: $input) {
      __typename
      ...ScreenerIndicatorFields
    }
  }
  ${ScreenerIndicatorFieldsFragment}
`;
